import { setLifeTime, setQRCodeData, setStep } from "../../redux/payment/slice";
import {
  PAYMENT_METHODS_ENUM,
  PAYMENT_STEPS,
} from "../../types/PaymentMethodsTypes";
import { redirectToUrl, setPaymentPage } from ".";
import { noActionHandler } from "./noActionHandler";

const handlerUPIS = (data, dispatch) => {
  if (data.data) {
    dispatch(setStep(PAYMENT_STEPS.APP_CHOISE));
    dispatch(setQRCodeData(data.data.qr_data));
    dispatch(setLifeTime(60 * 3 * 1000));
  } else if (data.paymentPageUrl) {
    dispatch(setStep(PAYMENT_STEPS.QR_CODE));
    dispatch(setQRCodeData(data.paymentPageUrl));
    dispatch(setLifeTime(60 * 14 * 1000));
  } else {
    dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};

const standardHandlerTransaction = (dataKey, data, dispatch) => {
  if (data[dataKey]) {
    dispatch(setStep(PAYMENT_STEPS.SUCCESS));
  } else {
    dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};

export const standardHandler = (dataKey) => (data, dispatch) => {
  switch (dataKey) {
    case "redirectUrl":
    case "link":
    case "paymentUrl":
      redirectToUrl(dataKey, data, dispatch);
      break;
    case "pluginUrl":
      setPaymentPage(dataKey, data, dispatch);
      break;
    case "data":
    case "paymentPageUrl":
      handlerUPIS(data, dispatch);
      break;
    case "transactionId":
      standardHandlerTransaction(dataKey, data, dispatch);
      break;
    case "noAction":
      noActionHandler(dispatch, data.statusCode);
      break;
    default:
      dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};

const specialRedirectHandler = (dataKey) => (data, dispatch) => {
  if (dataKey === "redirectUrl") {
    dispatch(setStep(PAYMENT_STEPS.QR_CODE));
    dispatch(setQRCodeData(data.redirectUrl));
    dispatch(setLifeTime(60 * 14 * 1000));
  } else {
    standardHandler(dataKey)(data, dispatch);
  }
};

export const PAYMENT_METHOD_ACTIONS = {
  [PAYMENT_METHODS_ENUM.ANINDA_HAVALE]: standardHandler("link"),
  [PAYMENT_METHODS_ENUM.AZARPAY]: standardHandler("link"),
  [PAYMENT_METHODS_ENUM.BANK_CARDS_TRY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.BANKTRANSFER]: standardHandler("pluginUrl"),
  [PAYMENT_METHODS_ENUM.BKASH_P2C]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.COREFY]: standardHandler("pluginUrl"),
  [PAYMENT_METHODS_ENUM.CC]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.TROY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.EXPRESS_HAVALE]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.HAVALE_HERA]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.HAVALE_VIP]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.INSTAKK]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.IPAY]: standardHandler("pluginUrl"),
  [PAYMENT_METHODS_ENUM.KPAY]: standardHandler("pluginUrl"),
  [PAYMENT_METHODS_ENUM.MEFETE]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.MPESA]: standardHandler("transactionId"),
  [PAYMENT_METHODS_ENUM.NAGAD_P2C]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAPARA]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYFIX]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.UPAY]: standardHandler("pluginUrl"),
  [PAYMENT_METHODS_ENUM.UPIS]: standardHandler("data"),
  [PAYMENT_METHODS_ENUM.UZCARD]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.UZCARD_PAYCOS]: standardHandler("link"),
  [PAYMENT_METHODS_ENUM.WAVEPAY]: standardHandler("pluginUrl"),
  [PAYMENT_METHODS_ENUM.JAZZCASH_PAYKASSMA]: standardHandler("pluginUrl"),
  [PAYMENT_METHODS_ENUM.WP_BKASH]: standardHandler("paymentUrl"),
  [PAYMENT_METHODS_ENUM.WP_NAGAD]: standardHandler("paymentUrl"),
  [PAYMENT_METHODS_ENUM.UPIV_GOOGLE]: standardHandler("paymentPageUrl"),
  [PAYMENT_METHODS_ENUM.UPIV_PHONEPE]: standardHandler("paymentPageUrl"),
  [PAYMENT_METHODS_ENUM.CONSTANTPOS_GOOGLE]:
    specialRedirectHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.CONSTANTPOS_PHONPE]:
    specialRedirectHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.CONSTANTPOS_PAYTM]:
    specialRedirectHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.ZENPAY_GOOGLE]: standardHandler("paymentPageUrl"),
  [PAYMENT_METHODS_ENUM.ZENPAY_PHONEPE]: standardHandler("paymentPageUrl"),
  [PAYMENT_METHODS_ENUM.ZENPAY_PAYTM]: standardHandler("paymentPageUrl"),
  [PAYMENT_METHODS_ENUM.AZARPAY_VALERPAY]: standardHandler("paymentUrl"),
  [PAYMENT_METHODS_ENUM.CASHIX_BKASH]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.CAHSIX_NAGAD]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.APAY_BKASH]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.APAY_NAGAD]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.VALERPAY_M10]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.VALERPAY_MPAY]: standardHandler("paymentUrl"),
  [PAYMENT_METHODS_ENUM.SMARTPROPAY_M10]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.SMARTPROPAY_MPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.MAKSIPARA_BANKTRANSFER]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.MAKSIPARA_PEPPARA]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.MAKSIPARA_PAPARA]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.MAKSIPARA_PAYFIX]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.MAKSIPARA_POPYPARA]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.MAKSIPARA_PAYBOL]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.ESEWA]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.KHALTI]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.AP_UPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.AP_JAZZCASH]: standardHandler("noAction"),
  [PAYMENT_METHODS_ENUM.AP_EASYPAISA]: standardHandler("noAction"),
  [PAYMENT_METHODS_ENUM.OCTOPAYS_NAGAD]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.OCTOPAYS_BKASH]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.CASHIX_MOMOPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.CASHIX_VIETQR]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.AP_BANKALFALAH]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.VVP_KREDIKARTI]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.BITOLO_BANKTRANSFER]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.BITOLO_MOMOPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.BITOLO_ZALOPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.BITOLO_VIETTELPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.BITOLO_VIETQR]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.WANGUPAY_VIET_QR]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.SPAYZ_BANKTRANSFER]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.SPAYZ_VIRTUALACCOUNT]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.UMMONEY_KHALTY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.UMMONEY_ESEWA]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.UMMONEY_CELLPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.UMMONEY_IMEPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.EASYPAYGAME_EASYPAISA]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.EASYPAYGAME_JAZZCASH]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYOK_MOMOPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYOK_ACB_VIET_QR]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYOK_BIDV_QR]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYOK_VIETCOM_QR]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYOK_VIET_QR]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYOK_TECHCOM_VIET_QR]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYOK_VIETTEL_PAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.PAYOK_BANKTRANSFER]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.INWIZO_EMANAT]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.INWIZO_M10]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.INWIZO_M10_WALLET]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.INWIZO_M10_BANK_CARD]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.COREFY_NAGAD]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.COREFY_BKASH]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.OCTOPAYS_BKASH_P2P]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.OCTOPAYS_NAGAD_P2P]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.BOVA_BANKTRANSFER]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.BOVA_CLICKTOSS]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.HAVALE_FAST_MPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.HAVALE_MPAY]: standardHandler("redirectUrl"),
  [PAYMENT_METHODS_ENUM.FLASHPAY_KAKAOPAY]: standardHandler("redirectUrl"),
};
